function normalizeDraftValue(value) {
  return String(value === undefined || value === null ? "" : value)
}

function hasExplicitConceptId(conceptId) {
  return conceptId !== undefined && conceptId !== null && String(conceptId).trim() !== ""
}

function clearStoredDraft(storage, key) {
  try {
    storage.removeItem(key)
  } catch (error) {}
}

function readValidBookingDraft({ storage, key, expectedVersion, now, promotionCode, routeConceptId }) {
  try {
    const raw = storage.getItem(key)
    if (!raw) {
      return null
    }

    const draft = JSON.parse(raw)
    const matchesVersionAndTime = draft && draft.version === expectedVersion && Number(draft.expiresAt) > now
    const matchesPromotion = draft && normalizeDraftValue(draft.promotionCode) === normalizeDraftValue(promotionCode)
    const matchesExplicitConcept =
      !hasExplicitConceptId(routeConceptId) ||
      (draft && normalizeDraftValue(draft.conceptId) === normalizeDraftValue(routeConceptId))

    if (!matchesVersionAndTime || !matchesPromotion || !matchesExplicitConcept) {
      clearStoredDraft(storage, key)
      return null
    }

    return draft
  } catch (error) {
    clearStoredDraft(storage, key)
    return null
  }
}

module.exports = {
  readValidBookingDraft,
}
